import React, { CSSProperties, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as ReportsActions from './../actions/reportsActions'
import { RootState } from '../../../store/rootState'
import { ContentHeader } from '../../../components/Header/ContentHeader'
import { IReportFilter } from '../types/reports'
import { useLocation } from 'react-router-dom'
import { ICustomizedState } from '../../../types/history'

interface StateProps {
  reportsFilters: IReportFilter[]
  reportsFilter: IReportFilter
}

interface DispatchProps {
  getReports: (queryParams?: Record<string, string>) => void
  setReportFilter: (report: IReportFilter) => void
}

type Props = DispatchProps & StateProps

const badgeStyle: CSSProperties = {
  borderRadius: '7.2px',
  height: '2rem',
  fontSize: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer'
}

const ReportsHeaderContainer = (props: Props) => {
  const { reportsFilters, reportsFilter, getReports, setReportFilter } = props

  const [showTabs, setShowTabs] = useState(false)

  const location = useLocation()

  useEffect(() => {
    getReports()
  }, [getReports])

  useEffect(() => {
    const locArr = location.pathname.split('/').filter(path => path !== '')
    const _locationState = location.state as ICustomizedState
    if (_locationState && _locationState.report) {
      setReportFilter(_locationState.report)
    }
    setShowTabs(locArr.length === 1)
  }, [location, setReportFilter])

  const handleTypeClicked = (type: IReportFilter) => {
    setReportFilter({ ...type })
  }

  const leftItems = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '1.5rem', justifyContent: 'space-between', width: '50%' }}>
        {reportsFilters.map(l => {
          return (
            <div
              onClick={() => handleTypeClicked(l)}
              style={{ ...badgeStyle, color: l.key !== reportsFilter.key ? '#747678' : '#232C58', minWidth: l.minWidth, background: l.key === reportsFilter.key ? '#1a232c24' : '' }}
              key={l.key}>
              {l.name} {l.count !== undefined ? `(${l.count})` : ''}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <ContentHeader
      title={showTabs ? 'Reports' : ''}
      color='#232C58'
      backTitle={showTabs ? '' : 'Reports'}
      backLocation={`/reports`}
      leftItems={showTabs ? leftItems() : undefined}
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    reportsFilters: state.reportsState.reportsFilters,
    reportsFilter: state.reportsState.reportsFilter,
  }
}

const mapDispatchToProps = (dispatch: ReportsActions.ReportsThunkDispatchType): DispatchProps => {
  return {
    getReports: queryParams => dispatch(ReportsActions.getReports(queryParams)),
    setReportFilter: report => dispatch(ReportsActions.setReportsFilter(report)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsHeaderContainer)
